import { render, staticRenderFns } from "./detailsAdd.vue?vue&type=template&id=adc8b7e8&scoped=true&"
import script from "./detailsAdd.vue?vue&type=script&lang=js&"
export * from "./detailsAdd.vue?vue&type=script&lang=js&"
import style0 from "./detailsAdd.vue?vue&type=style&index=0&id=adc8b7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc8b7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adc8b7e8')) {
      api.createRecord('adc8b7e8', component.options)
    } else {
      api.reload('adc8b7e8', component.options)
    }
    module.hot.accept("./detailsAdd.vue?vue&type=template&id=adc8b7e8&scoped=true&", function () {
      api.rerender('adc8b7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicFiles/components/detailsAdd.vue"
export default component.exports